import React from "react";
import etiqueta from "../../../images/etiqueta_cartelera.png";
import Button from '../../elements/buttons/Button';


const HeroCartelera = () =>(
    <>
        <section className="HeroCartelera">
            
                <div className="wrap">
                    <div>
                        <img src={etiqueta} className=""/>
                        <h3 className="titlesBig">LAS MEJORES <br />SERIES Y PELICULAS</h3>
                        <p>Estrenos exclusivos y más, para no dejar <br /> de maratonear.</p>
                        <Button copy="Pruebalo gratis" link="/" className="button-solid-grad-pink button-icon" />
                    </div>
                </div>
                <div className="backgroundImage"></div>
        </section>
    </>
)

export default HeroCartelera;